import { render, staticRenderFns } from "./UsdBankData.vue?vue&type=template&id=3b7f859b&scoped=true&"
import script from "./UsdBankData.vue?vue&type=script&lang=ts&"
export * from "./UsdBankData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f859b",
  null
  
)

export default component.exports